<template>
  <a
    :href="path"
    class="btn btn-naked report-scheduled-reports-link"
  >
    <i class="hi hi-time hi-16"></i>
    Scheduled reports
  </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      path: 'getScheduledReportsUrl',
    }),
  },
};
</script>
